export const isNotFoundRequest = text => /code 404/i.test(text);
